module.exports = __webpack_public_path__ + "img/Feature.c6de39a3.jpg";